module.exports = __webpack_public_path__ + "img/back_m2.29d9079e.png";